import { Converter } from '../types/converter';

export const digitalImageResolutionConverter: Converter = {
  id: 'digitalImageResolution',
  name: 'Digital Image Resolution Converter',
  icon: 'Image',
  categories: ['digital'],
  units: [
    { name: 'Dot/meter', symbol: 'dot/m', factor: 1 },
    { name: 'Dot/millimeter', symbol: 'dot/mm', factor: 1000 },
    { name: 'Dot/inch', symbol: 'dot/in', factor: 25.4 },
    { name: 'Pixel/inch', symbol: 'pixel/in', factor: 25.4 }
  ]
};
